export default "__VITE_ASSET__DhH$4l7E__"